import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as leadsService from "../../services/leads.services";
import * as inquiriesService from "../../services/inquiry.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
  usePermission,
} from "../../../../utils/commonfunction";
import CustomRangepicker from "../../common/rangepicker";
import Swal from "sweetalert2";
import { INQUIRY_STATUS, showFilterlist, SWAL_SETTINGS } from "../../../../utils/Constants";
import StatusFilter from "../../common/statusFilter";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import * as $ from 'jquery';
import { useSearchParams } from "react-router-dom";

const LeadsTable = () => {
  const { can } = usePermission();
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [searchParams] = useSearchParams();

  // const [search] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({
    ...(searchParams.get("status") ? { status: searchParams.get("status") } : {}),
  });
  console.log(search, 222);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_leads"), url: "" },
  ];
  const showInquiryFilterList = [
    { name: "list_heading_status", status__id: "" },
    { name: "new", status__id: "new" },
    { name: "responded", status__id: "responded" },
    { name: "in_progress", status__id: "in_progress" },
    { name: "closed", status__id: "closed" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {

      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        leadsService
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data?.data?.list : []);
            // console.log("data.data.=====>", data.data);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }

    }, 300);
    return () => clearTimeout(getData)

  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);


  const viewfunction = (row) => {
    navigate(`/admin/leads/view/${row._id}`);
  };


  const markResolve = (row, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("confirm_inquiry_status_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_resolve"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();

        formdata.append("_id", row._id);
        formdata.append("status", status)
        inquiriesService.resolveInquiry(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }




  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function

  const prepareSearch = (key, value) => {

    console.log('key---', key, value)
    const statusLabelMap = {
      "New": "new",
      "Responded": "responded",
      "In Progress": "in_progress",
      "Closed": "closed",
    };

    let sr;

    if (statusLabelMap[value]) {
      sr = { "status": statusLabelMap[value] };
    }

    else {
      sr = { ...search };
      if (String(value).length > 0) {
        sr[key] = value;
      } else {
        delete sr[key];
      }
    }

    if (value && typeof value === "string" && value.toLowerCase() === "status") {
      sr = {};
    }




    console.log('sr---', sr)
    setSearch(sr);
  };


  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  // const goToEdit = (row) => {
  //   navigate(
  //     `/admin/testimonial-management/testimonial/${params.pgno}/edit/${row._id}`
  //   );
  // };

  const Deletefunction = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#403fad',
      cancelButtonColor: '#f1388b',
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        let id = row._id;
        const formdata = new FormData();
        formdata.append("_id", id);
        leadsService.Delete(formdata).then(response => {
          setStatusUpdate(!statsupdate)
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })

  }

  const ChangeStatus = (data, Num) => {
    const formData = new FormData();
    formData.append("_id", JSON.stringify(data).replaceAll('"', ""));
    formData.append("isStreamApproved", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        leadsService
          .Status(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("sidebar_link_leads")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showInquiryFilterList}
                    prepareSearch={prepareSearch}
                    selectedStatus={search?.status || ""}
                  />
                </div>

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {loader ?
              <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              :
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered border-t0 table table-bordered card-table border-top text-nowrap w-100 text-nowrap w-100">
                    <thead>
                      <tr>
                        <th className="position-relative select_head">
                          <span>{t("list_heading_sno")}</span>
                        </th>

                        <th>
                          <div className="rating_head">
                            <span>{t("list_heading_image")}</span>
                          </div>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("list_heading_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="product.title"
                            />
                          </div>
                        </th>

                        <th>
                          <div className="sorting_column">
                            <span>{t("label_seller")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="seller.name"
                            />
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_store_name")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="seller.store_name"
                            />
                          </div>
                        </th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_buyer")}</span>
                            <Sorting
                              sort={sorting}
                              handleSort={handleSort}
                              column="buyer.name"
                            />
                          </div>
                        </th>
                        {/* <th className="status_head">{t("list_heading_live_status")}</th> */}
                        <th className="status_head">{t("list_heading_status")}</th>

                        <th className="action_head">{t("list_heading_action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >

                                <td>
                                  {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                </td>

                                <td>
                                  {row?.product?.image || (row?.product?.frames && row?.product?.frames.length > 0 && row.product.frames[0].frame_url) ? (
                                    <img
                                      src={row?.product?.image || row.product.frames[0].frame_url}
                                      alt={row?.product?.title || "Product"}
                                      className="rounded border"
                                      style={{ width: "45px", height: "45px", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <div
                                      className="bg-light rounded d-flex align-items-center justify-content-center text-muted"
                                      style={{ width: "45px", height: "45px", fontSize: "10px" }}
                                    >
                                      N/A
                                    </div>
                                  )}
                                </td>

                                <td>
                                  {row?.product?.title ? (
                                    <div className="d-flex">
                                      {row?.product?.title ? capitalizeFirstLetter(TrimText(row.product.title, 50)) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  {row?.seller?.name
                                    ? <div className="d-flex capitalize">{capitalizeFirstLetter(TrimText(row?.seller?.name, 20))}</div>
                                    : "N/A"}
                                </td>

                                <td>
                                  {row?.seller?.store_name
                                    ? <div className="d-flex capitalize">{capitalizeFirstLetter(TrimText(row?.seller?.store_name, 25))}</div>
                                    : "N/A"}
                                </td>

                                <td>
                                  {row?.buyer?.name
                                    ? <div className="d-flex capitalize">{capitalizeFirstLetter(TrimText(row?.buyer?.name, 20))}</div>
                                    : "N/A"}
                                </td>
                                {/* <td>
                                  {row ? (
                                    <div className="d-flex">
                                      {row.isLive === true && row.isStreamCompleted === true
                                        ? t("running")
                                        : t("completed")}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td> */}

                                <td>
                                  {row ? (
                                    <div className="d-flex capitalize">
                                      {removeSpecialCharacter(row?.status)}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td>

                                <td>
                                  <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                      <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                        <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                          <i className="ri-eye-fill"></i>
                                        </button>
                                      </Whisper>
                                      {can("/admin/leads/delete") && (
                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                          <button type="button" className="btn delete" onClick={() => { Deletefunction(row) }}>
                                            <i className="ri-delete-bin-6-fill"></i>
                                          </button>
                                        </Whisper>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={8} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div
                  className=""
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >
                  <b>
                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                  </b>
                </div>
                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "Reataurant",
                        path: "/admin/leads/list",
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
              </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default LeadsTable;
